.RotaryKnob {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    user-select: none;
    touch-action: none;

    &.isVariantInfo {
        & .RotaryKnob__arc {
            stroke: var(--soniq-t--global--palette--cyan);
        }

        & .RotaryKnob__pointer {
            background: var(--soniq-t--global--palette--cyan);
        }
    }
}

.RotaryKnob__stage {
    position: relative;
    width: 96px;
    height: 96px;
}

.RotaryKnob__scale {
    position: absolute;
    inset: 0;
    pointer-events: none;
}

.RotaryKnob__tick {
    stroke: var(--soniq-t--global--border--color--grid--strong);
    stroke-width: 1.5;
}

.RotaryKnob__track {
    fill: none;
    stroke: var(--soniq-t--global--background--color--surface--input);
    stroke-width: 4;
    stroke-linecap: round;
}

.RotaryKnob__arc {
    fill: none;
    stroke: var(--soniq-t--global--palette--hot-pink);
    stroke-width: 4;
    stroke-linecap: round;
    transition: stroke 120ms ease;
}

.RotaryKnob__dial {
    position: absolute;
    inset: 16px;
    border-radius: 50%;
    border: 1px solid var(--soniq-t--global--border--color--event--opaque);
    background: radial-gradient(circle at 32% 28%, var(--soniq-t--global--background--color--surface--hover), transparent 55%),
    var(--soniq-t--global--background--color--surface--panel-opaque);
    box-shadow: 0 6px 14px var(--soniq-t--global--text--shadow--subtle);
    cursor: ns-resize;

    &:focus-visible {
        outline: 2px solid var(--soniq-t--global--border--color--accent--today--default);
        outline-offset: 3px;
    }
}

.RotaryKnob__pointer {
    position: absolute;
    top: 5px;
    left: calc(50% - 2px);
    width: 4px;
    height: 20px;
    border-radius: 2px;
    background: var(--soniq-t--global--palette--hot-pink);
}

.RotaryKnob__label {
    font-size: var(--soniq-t--global--font--size--field-label);
    font-weight: var(--soniq-t--global--font--weight--medium);
    letter-spacing: var(--soniq-t--global--font--letter-spacing--wide);
    text-transform: uppercase;
    color: var(--soniq-t--global--text--color--label--default);
}

.RotaryKnob__value {
    font-family: var(--soniq-t--global--font--family--mono);
    font-size: var(--soniq-t--global--font--size--date);
    color: var(--soniq-t--global--text--color--primary--default);
    background: var(--soniq-t--global--background--color--surface--input);
    border: 1px solid var(--soniq-t--global--border--color--input--default);
    border-radius: 6px;
    padding: 2px 8px;
    min-width: 64px;
    text-align: center;
}

@media (prefers-reduced-motion: reduce) {
    .RotaryKnob__arc {
        transition: none;
    }
}
